import { createContext } from "react";
import type { LightboxContextValue, InlineContainerContextValue } from "./types";

export const LightboxContext = createContext<LightboxContextValue | null>(null);

export const InlineContainerContext = createContext<InlineContainerContextValue | null>(null);
